/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FileMobileIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'File Mobile',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10 2v10H0L10 2zM33 8H19a1 1 0 0 0-1 1v24a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1Zm-8 2h2a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2Zm1 23.1a2.1 2.1 0 1 1 2.1-2.1 2.1 2.1 0 0 1-2.1 2.1Zm6-5.1H20V14h12Z"
    />
    <path
      d="M16 32V8.481A2.481 2.481 0 0 1 18.481 6H26V3a1 1 0 0 0-1-1H12v11a1 1 0 0 1-1 1H0v19a1 1 0 0 0 1 1h15.557A3.953 3.953 0 0 1 16 32Z"
    />
  </svg>`;
};
